import React from "react";
import { Box } from "@mui/material";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
    block: {
        display: 'flex',
        gap: '32px',
        [theme.breakpoints.down('sm')]: {
            gap: '16px',
        },
    },
    title: {
        color: 'rgb(85, 95, 126)',
        fontSize: '14px',
        fontWeight: 700,
        lineHeight: '22px'
    },
    paragraph: {
        color: 'rgb(85, 95, 126)',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '22px'
    }
}))


function AttentionBlock(props) {
    const { title, paragraph } = props;
    const classes = useStyles();

    return (
        <Box className={classes.block}>
            <svg style={{ width: "35px", height: "35px", minWidth: '35px', minHeight: '35px' }} viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3882 0.0324024L15.5438 0.119902C11.4466 0.528965 7.31883 2.64209 4.52758 5.76146C1.44102 9.21115 -0.127421 13.4921 0.0169543 18.053C0.268517 25.9302 5.68258 32.5999 13.3629 34.4987C15.6242 35.0447 17.9713 35.1364 20.2683 34.7684C22.5653 34.4004 24.7663 33.58 26.7438 32.3549C30.6327 29.9319 33.4162 26.0803 34.4963 21.6274C34.8726 20.094 34.9601 19.313 34.9601 17.4996C34.9601 15.6862 34.8726 14.9052 34.4963 13.3718C32.7638 6.29522 26.9363 1.08896 19.6848 0.13959C19.0635 0.0586524 16.8038 -0.0135351 16.3882 0.0324024ZM19.3632 3.41865C21.8204 3.74212 24.1508 4.70038 26.1248 6.19897C26.8445 6.73709 28.2598 8.1524 28.7979 8.87209C30.0251 10.5149 30.9329 12.4465 31.3441 14.2949C31.8123 16.4057 31.8123 18.5935 31.3441 20.7043C30.4385 24.7752 27.5707 28.389 23.7688 30.2483C22.3982 30.9191 20.932 31.3736 19.4223 31.5958C18.4948 31.738 16.4998 31.738 15.5723 31.5958C11.311 30.9483 7.71477 28.623 5.4507 25.0487C4.89381 24.1253 4.42927 23.1494 4.06383 22.1349C3.54279 20.6459 3.28735 19.077 3.30914 17.4996C3.30914 15.2268 3.74883 13.2887 4.72227 11.2871C5.46602 9.76021 6.22289 8.70584 7.4632 7.46553C8.56025 6.32764 9.8552 5.39886 11.2848 4.72459C13.7895 3.50104 16.6005 3.04662 19.3632 3.41865ZM16.8541 9.38397C16.3641 9.54365 16.0863 9.82365 15.9507 10.2918C15.872 10.5587 15.8632 11.169 15.8763 14.9096C15.8938 19.219 15.8938 19.2212 16.0207 19.4596C16.1874 19.765 16.4549 20.0032 16.7776 20.1333C17.0663 20.234 17.9282 20.234 18.217 20.1333C18.5396 20.0032 18.8071 19.765 18.9738 19.4596C19.1007 19.2212 19.1007 19.219 19.1182 14.9096C19.1357 10.2021 19.1357 10.1977 18.801 9.80178C18.5298 9.47803 18.2388 9.37084 17.5848 9.35334C17.3408 9.33959 17.0961 9.34985 16.8541 9.38397ZM17.0291 23.034C16.5915 23.1905 16.2275 23.5038 16.0076 23.9133C15.8497 24.3057 15.8304 24.7401 15.9529 25.1449C16.0712 25.4618 16.2813 25.7362 16.5564 25.933C16.8316 26.1298 17.1591 26.24 17.4973 26.2496C18.1601 26.2496 18.836 25.7683 19.0416 25.1449C19.1642 24.7401 19.1449 24.3057 18.987 23.9133C18.8059 23.5938 18.5432 23.3281 18.2257 23.1433C17.972 23.0121 17.2873 22.9487 17.0291 23.034Z" fill="#FFBE00" />
            </svg>
            <div>
                <b className={classes.title}>
                    {title}
                </b>
                <hr
                    color="#FFBE00"
                />
                <p className={classes.paragraph}>
                    {paragraph}
                </p>
            </div>
        </Box>
    );
}

export default AttentionBlock;